import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot, UrlTree } from '@angular/router';
import { IAppState } from '../../../app/app.reducer';
import { select, Store } from '@ngrx/store';
import { selectFreightTypesEnabled } from '../user.reducer';
import { Observable } from 'rxjs';

export const accessToContainersGuard: CanActivateFn = (route, state) => {
  const store$ = inject(Store<IAppState>);

  return new Observable<boolean | UrlTree>((observer) => {
    store$.select(selectFreightTypesEnabled).subscribe((freightTypesEnabled) => {
      if (freightTypesEnabled?.containersEnabled) {
        observer.next(true);
        observer.complete();
      } else {
        observer.next(createUrlTreeFromSnapshot(route, ['']));
        observer.complete();
      }
    });
  });
};
